// Aba ScontiPoste no painel do Manager (adesao ao canal)
const channelSellerDictIT = {
  settingsTabScontiPoste: "ScontiPoste",
  channelSellerTitle: "Vendi su ScontiPoste",
  channelSellerIntro: "ScontiPoste è il programma di cashback di Poste Italiane per chi ha una carta Postepay o BancoPosta. Con l'adesione, i tuoi prodotti idonei compaiono nella vetrina Extraconomy per ScontiPoste.",
  channelSellerOnlyManagers: "Solo i Manager possono vendere su ScontiPoste.",
  channelSellerEligibleCount: "Prodotti idonei: {count}",
  channelSellerListedCount: "Prodotti in vetrina: {count}",
  channelSellerNoEligible: "Nessun prodotto idoneo per ora. Controlla sotto cosa manca a ciascun prodotto.",
  channelSellerTerms: "Condizioni",
  channelSellerTerm1: "Su ogni vendita in ScontiPoste trattieni il {percent}% del valore dei prodotti come cashback ScontiPoste. Al cliente lo accredita Poste Italiane.",
  channelSellerTerm2: "La commissione Extraconomy e le commissioni della rete restano quelle di sempre.",
  channelSellerTerm3: "Vendi solo prodotti in euro con spedizione gratuita a tuo carico o con ritiro in negozio.",
  channelSellerTerm4: "Puoi uscire quando vuoi: i prodotti spariscono subito dalla vetrina e gli ordini già ricevuti restano da evadere.",
  channelSellerTermsOutdated: "Il cashback ScontiPoste è passato al {percent}%. I tuoi prodotti sono fuori dalla vetrina finché non accetti la nuova percentuale.",
  channelSellerAcceptNew: "Accetta il {percent}%",
  channelSellerAccept: "Accetto le condizioni di vendita su ScontiPoste",
  channelSellerMode: "Cosa mettere in vetrina",
  channelSellerModeAll: "Tutti i prodotti idonei, anche quelli che aggiungerò",
  channelSellerModeSelected: "Solo i prodotti che scelgo",
  channelSellerJoin: "Aderisci a ScontiPoste",
  channelSellerJoined: "Sei su ScontiPoste dal {date}, con il {percent}% di cashback.",
  channelSellerChannelInactive: "La vetrina ScontiPoste non è ancora aperta al pubblico: i tuoi prodotti compariranno all'apertura.",
  channelSellerOpenShowcase: "Apri la vetrina",
  channelSellerProducts: "I tuoi prodotti",
  channelSellerSave: "Salva prodotti",
  channelSellerSaved: "Prodotti salvati",
  channelSellerLeave: "Esci da ScontiPoste",
  channelSellerLeaveConfirm: "I tuoi prodotti spariscono subito dalla vetrina ScontiPoste. Gli ordini già ricevuti restano da evadere. Vuoi uscire?",
  channelSellerLeft: "Sei uscito da ScontiPoste",
  channelSellerJoinedToast: "Adesione confermata",
  channelSellerAcceptRequired: "Accetta le condizioni per aderire.",
  channelReasonSELLER_TYPE: "Solo Manager",
  channelReasonNOT_PUBLISHED: "Non pubblicato",
  channelReasonSHIPPING_OPTION: "Spedizione a pagamento: usa spedizione gratuita o ritiro in negozio",
  channelReasonCURRENCY: "Prezzo non in euro",
  channelReasonDOWNLOADABLE: "Prodotto digitale",
  channelReasonSERVICE: "Servizio",
  channelReasonDROPSHIPPING: "Prodotto importato (dropshipping)",
  channelReasonOUT_OF_STOCK: "Esaurito",
  channelError500435: "Solo i Manager possono vendere su ScontiPoste.",
  channelError500436: "Accetta le condizioni per aderire.",
  channelError500437: "Non hai ancora aderito a ScontiPoste.",
};

export default channelSellerDictIT;
